import { Field, Formik } from "formik";
import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoginQuery } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { checkUser, saveDatatoLocalStorage } from "../../util/utils";
import { LoginwithEmailSchema } from "../../util/validationSchema";
import ErrorMessageFormik from "../CommanComponents/ErrorMessageFormik";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  handleLoader = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  handleAfterApiCall = (data) => {
    saveDatatoLocalStorage("user_id", data.user_id);
    saveDatatoLocalStorage("image", data.image);
    const userRole = data.user_role;
    const _userRole = [];
    userRole.map((role) => {
      return(
      _userRole.push(role.identifier)
      )
    });

    saveDatatoLocalStorage("user_group", JSON.stringify(data.user_group));
    saveDatatoLocalStorage("user_role", JSON.stringify(_userRole));
    let { from } = this.props.location.state || {
      from: { pathname: "/dashboard" },
    };
    window.location.href = from.pathname;
  };

  handleSubmit = (values) => {
    const { email, password } = values;
    apiCall(
      METHOD.QUERY,
      LoginQuery(email, password),
      (data) => this.handleAfterApiCall(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  componentDidMount() {
    if (checkUser()) {
      this.props.history.push("/dashboard");
    }
  }

  render() {
    const { isLoading } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              validationSchema={LoginwithEmailSchema(
                t("LoginScreen.emailrequire"),
                t("LoginScreen.validEmailRequire"),
                t("LoginScreen.passwordRequire")
              )}
              onSubmit={(values) => {
                this.handleSubmit(values);
              }}
            >
              {({ handleSubmit }) => (
                <div className="content-wrapper">
                  <div className="login-container d-flex align-items-center justify-content-center">
                    <div className="card shadow-sm login-box">
                      <div className="card-header pt-4 border-0">
                        <img
                          src="assets/img/bootstrap-solid.svg"
                          className="d-block mx-auto mb-3"
                          width="45"
                          alt="Logo"
                        />
                        <h2 className="h4 text-center mb-3">
                          {t("LoginScreen.loginLable")}
                        </h2>
                        <p className="text-center mb-0">
                          {t("LoginScreen.loginTitle")}
                        </p>
                      </div>
                      <div className="card-body">
                        <div className="form-group">
                          <Field
                            type="email"
                            name="email"
                            className="form-control form-control-lg"
                            placeholder={t("LoginScreen.emailPlaceHolder")}
                            required
                          />
                          <small
                            id="emailHelp"
                            className="form-text text-danger"
                          >
                            <ErrorMessageFormik name="email" />
                          </small>
                        </div>
                        <div className="form-group">
                          <Field
                            name="password"
                            className="form-control form-control-lg"
                            placeholder={t("LoginScreen.passwordPlaceHolder")}
                            type="password"
                            required
                          />

                          <small
                            id="emailHelp"
                            className="form-text text-danger"
                          >
                            <ErrorMessageFormik name="password" />
                          </small>
                        </div>

                        {isLoading ? (
                          <button
                            type="button"
                            onClick={handleSubmit}
                            className="btn btn-primary btn-block mt-4"
                          >
                            Login
                            <div className="spinner-border spinner-border-sm ml-1 text-white">
                              <span className="sr-only">
                                {t("GeneralMessages.loading")}
                              </span>
                            </div>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={handleSubmit}
                            className="btn btn-primary btn-block btn-lg mt-4"
                          >
                            {t("LoginScreen.btnLogin")}
                          </button>
                        )}
                      </div>
                      <div className="card-footer d-flex justify-content-between border-0 pt-2">
                        <div className="password-reset-link float-right">
                          <Link to="/forgotpassword" className="text-primary">
                            {t("LoginScreen.forgotPassTitle")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(Login));
